import React, { useMemo } from 'react';
import { Button, Heading, Image, Text, useColorModeValue } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import inverterCellularImg from '../../../../assets/images/inverter_cellular.svg';
import inverterEthernetImg from '../../../../assets/images/inverter_ethernet.svg';
import { ArcButton } from '../../../../common/components/ArcButton';
import { HardwareConnectionType } from '../types';

/* istanbul ignore next -- @preserve */
export function InverterConnection({
  type,
  onClickWifi,
  onClickSkip,
  isLoading,
}: {
  type: HardwareConnectionType;
  onClickWifi: () => void;
  onClickSkip: (type: HardwareConnectionType) => void;
  isLoading: boolean;
}) {
  const { t } = useTranslation();
  const color = useColorModeValue('#1E79B6', '#42B4E6');

  const src = useMemo(() => {
    if (type === 'CELLULAR_MODEM') return inverterCellularImg;
    if (type === 'ETHERNET') return inverterEthernetImg;
    return '';
  }, [type]);

  return (
    <>
      <Image w={'70%'} src={src} alt={type} my={4} />

      <Heading mt={2}>{t('Set Up Hardware.connection detected')}</Heading>
      <Text mt={1}>{t('Set Up Hardware.connection type', { type: type.toLowerCase().replace('_', ' ') })}</Text>
      <Text mt={1}>{t('Set Up Hardware.connection recommendation')}</Text>

      <ArcButton data-testid={'inverter-wifi-setup'} onClick={onClickWifi} mt={8} w={'80%'} arcColor="#3DCD57">
        {t('Set Up Hardware.setup wifi')}
      </ArcButton>
      <Button
        variant={'link'}
        data-testid={'inverter-wifi-skip'}
        onClick={() => onClickSkip(type)}
        mt={8}
        w={'80%'}
        fontWeight={500}
        color={color}
        isLoading={isLoading}
      >
        {t('Set Up Hardware.skip wifi')}
      </Button>
    </>
  );
}
